
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexLB9f880_45NplFy4T_wDBUaHwmrNp_45bx4aaZdN2W2yVYIMeta } from "/vercel/path0/apps/site/pages/index.vue?macro=true";
import { default as tgvNlROzUQiWHh_45Jlp3eibn95VVW7kQxMPwpivX6E8rEfQMeta } from "/vercel/path0/apps/site/pages/tgv.vue?macro=true";
import { default as loginmw9dUgU223jI0yzRlqeW6WCcVUg8rfn0u8c_gCK52BkMeta } from "/vercel/path0/apps/site/pages/login.vue?macro=true";
import { default as bonderYAWawE88qfsuZ717jW1Df3EcN7JizBHCd8vd8VVbnwQMeta } from "/vercel/path0/apps/site/pages/bonder.vue?macro=true";
import { default as eventsUYBmBJQ5HZ8EKSOoWGjA6XF8BHjrvjm4X6BBC0g4768Meta } from "/vercel/path0/apps/site/pages/events.vue?macro=true";
import { default as ownerscFeDwgl1BeTfwrI3mOjRc6gzcZjc_45UcbARIePi72wz4Meta } from "/vercel/path0/apps/site/pages/owners.vue?macro=true";
import { default as searchGoWTPY1ex8a452t20OtZbkm7K9_45fIW35GzeGLX9kWvUMeta } from "/vercel/path0/apps/site/pages/search.vue?macro=true";
import { default as tailorylcLZTiAU8QlBBXXjIGuv5MCZOAPoqKhiPGHl1KCNVwMeta } from "/vercel/path0/apps/site/pages/tailor.vue?macro=true";
import { default as vallatP6M9Tlw05obBVJpzCJbOfu1D_45n6DV1U3k3r5INlzFx4Meta } from "/vercel/path0/apps/site/pages/vallat.vue?macro=true";
import { default as contactp5Wa4d5J6FkfpkG9R_458BMnb3Q0ewVIszhBl5D0S4F9EMeta } from "/vercel/path0/apps/site/pages/contact.vue?macro=true";
import { default as sitemapGMW_WHUClYMrTe9YDN4_45e3BnHOkfpwfPXR5ewksEeFIMeta } from "/vercel/path0/apps/site/pages/sitemap.vue?macro=true";
import { default as addedValuehxgyIAxni6P3VKHNjvWkGZT9h5CE_ubay9SbGtFBpTEMeta } from "/vercel/path0/apps/site/pages/addedValue.vue?macro=true";
import { default as realEstateHth5mjxOs5qznNCuxzTdZ7L67xsp_45RfoF3bLx7Sb3x8Meta } from "/vercel/path0/apps/site/pages/realEstate.vue?macro=true";
import { default as inspiration1AJH__lc4a_oJN2LKioBOtcK8JU8CCyaEY20Qu6Cj10Meta } from "/vercel/path0/apps/site/pages/inspiration.vue?macro=true";
import { default as _91slug_93vZ_45CpD4xHYei0hpo6p9ZKpIrKEpCvFhAbjL9k76Fox4Meta } from "/vercel/path0/apps/site/pages/house/[slug].vue?macro=true";
import { default as photoshXV3YY2AEKcnmRi8eRkKra3kyhhfkCSUwThH74RnhUoMeta } from "/vercel/path0/apps/site/pages/house/photos.vue?macro=true";
import { default as _91id_93QX_Hb_zHdkg6WqCzE_gFFdKDwgDZWikp_450QhAuOkUb8Meta } from "/vercel/path0/apps/site/pages/feedback/[id].vue?macro=true";
import { default as customHolidayslyW27XxJn9NH_EXjE_0Y6Uj5saOm8IW0qpPq2EuZeNIMeta } from "/vercel/path0/apps/site/pages/customHolidays.vue?macro=true";
import { default as menuTDaGXdvnrSfjDMRngngFa9tHN4y4gi68DcHqpavIaGgMeta } from "/vercel/path0/apps/site/pages/myaccount/menu.vue?macro=true";
import { default as travelPartnersT_456qTUFBPLewkZ_OrL5smXShk0q5LaYIuEQLUVjYVc0Meta } from "/vercel/path0/apps/site/pages/travelPartners.vue?macro=true";
import { default as indexrX4h12gryidZzSlXMS2bYqE_459I8S5aSJaQwCA8LNNpEMeta } from "/vercel/path0/apps/site/pages/wishlist/index.vue?macro=true";
import { default as houseCollectionm50zkD_458A1Rr5P83z5UPJw2NS9janrUrcnzlJLPR4LEMeta } from "/vercel/path0/apps/site/pages/houseCollection.vue?macro=true";
import { default as termsOfUse_45xJaPIFwc7LwPp3MRaBWNEiYRr_45QSVR4JsEV0yMOjV8Meta } from "/vercel/path0/apps/site/pages/legal/termsOfUse.vue?macro=true";
import { default as profile_45_45QofDcg_45HYfb_45roMB6pHo_452GNEASp39HQYXR0FyaIkMeta } from "/vercel/path0/apps/site/pages/myaccount/profile.vue?macro=true";
import { default as editjGjjyiJ2FkUjWlc7WDEOFY7DbItEXElpG5i9xzMtC5AMeta } from "/vercel/path0/apps/site/pages/stayProposal/edit.vue?macro=true";
import { default as bookingsMJc49XW0mSm4a_45Qk1Y9B5DeDH3Qa8fY1i55OsZg1UgkMeta } from "/vercel/path0/apps/site/pages/myaccount/bookings.vue?macro=true";
import { default as realEstateListingsroN_h11Pu3XHi5UXJcPthf76QONDgDAZFH8a6_45dAo9wMeta } from "/vercel/path0/apps/site/pages/realEstateListings.vue?macro=true";
import { default as privacyPolicyyB53yXa0HVtDe_VlWt0FcfXYKeaiUQORvk_fCmbtPrcMeta } from "/vercel/path0/apps/site/pages/legal/privacyPolicy.vue?macro=true";
import { default as _91name_931Jh1iaJu_45HsBUYANnyHhqnBUH276zYFZth7yHNwyL7UMeta } from "/vercel/path0/apps/site/pages/[destination]/[name].vue?macro=true";
import { default as errorRyOCZSy6nGrdqDsu8bYACWFFaXHjylgQgK8pHSmIdysMeta } from "/vercel/path0/apps/site/pages/house/preorder/error.vue?macro=true";
import { default as indexgXQpU3P4vPdWcJb_45kCPQkKSivrE2_45Crq7vcd4xIL6WEMeta } from "/vercel/path0/apps/site/pages/house/preorder/index.vue?macro=true";
import { default as formDu8VU3krJK2k4Bl8mPfazFFxFao2MVoafTQCuXuiYbIMeta } from "/vercel/path0/apps/site/pages/payment/deposit/[id]/form.vue?macro=true";
import { default as errorbQt96nzQBwJIStSw01ClptgselYmI3sQI1Q2Y1af9iUMeta } from "/vercel/path0/apps/site/pages/payment/deposit/[id]/error.vue?macro=true";
import { default as successhSlpws43RKDxn325S10czwx76_adG2ihPWbfSjnQmdEMeta } from "/vercel/path0/apps/site/pages/payment/deposit/[id]/success.vue?macro=true";
import { default as _91id_93B_XHTZy8UDcVvpgRcNkqvGvF_45pCaYEZUFM0Pl_mHlRgMeta } from "/vercel/path0/apps/site/pages/payment/deposit/[id].vue?macro=true";
import { default as villabookfJnrB6Abe5bgeMoDiUak6H5WNBk2va5dn0z0_AX_e_45QMeta } from "/vercel/path0/apps/site/pages/screenshot/villabook.vue?macro=true";
import { default as _91token_938851rEqIcAP_VZ2GyUQ_45qYLFzB23BoiJR_45Rpzu0arGcMeta } from "/vercel/path0/apps/site/pages/stayProposal/[token].vue?macro=true";
import { default as ownerConditionsoDT7YXiHFgke3oxmJVdGeyhSOXLJlq3NwhxHdqUvsv8Meta } from "/vercel/path0/apps/site/pages/legal/ownerConditions.vue?macro=true";
import { default as errorlduhARou_AlfAoggVH5MQz_7g5T4eNiU2M6UjyFCZ1cMeta } from "/vercel/path0/apps/site/pages/payment/[payin]/error.vue?macro=true";
import { default as index3yDexzST5rsL0W7A5cli6hBTo8qL2EFnU0WsAk7EfMAMeta } from "/vercel/path0/apps/site/pages/payment/[payin]/index.vue?macro=true";
import { default as whitebrandBFscijZgCAxjdKEDGzrXQJzMUo9BwQL5ry5fUyOdhoYMeta } from "/vercel/path0/apps/site/pages/screenshot/whitebrand.vue?macro=true";
import { default as successoD_45VZ63umy8dMSoNzwIOFJLqoNMaAupRpS_HAXYlSI4Meta } from "/vercel/path0/apps/site/pages/house/preorder/success.vue?macro=true";
import { default as clientConditionsGonqByktirayVfY5Shkcn0ceIsS5VMlS8Zp5V2kHdywMeta } from "/vercel/path0/apps/site/pages/legal/clientConditions.vue?macro=true";
import { default as index_igeO5qBT4m3iQLlJuBQSU9JxHCvwd0IDvkXDn9xF_45oMeta } from "/vercel/path0/apps/site/pages/wishlist/[token]/index.vue?macro=true";
import { default as successZJ15YeIajLjOK3W9J54HEI02KYfeVuiP2Iyp2_45_9rTIMeta } from "/vercel/path0/apps/site/pages/payment/[payin]/success.vue?macro=true";
import { default as sharedA8lOEZF86gDn30yF4xCtHzHP1aTD1LWzq7n6KdCnaP0Meta } from "/vercel/path0/apps/site/pages/wishlist/[token]/shared.vue?macro=true";
import { default as _91slug_93zlln62r_u2695kmDVddOXZROaDHV6rxGfx_dZ__ZaR8Meta } from "/vercel/path0/apps/site/pages/house/transaction/[slug].vue?macro=true";
import { default as photosd55xP2CVvEmxoY3w9wWcecLTiJeN4bC5Eg9_45OP7UnmQMeta } from "/vercel/path0/apps/site/pages/house/transaction/photos.vue?macro=true";
import { default as indexaeu1vMOcDHkE7akfYQ01_45RJkRKbGIdxT2nsIXA2CcjIMeta } from "/vercel/path0/apps/site/pages/myaccount/documents/index.vue?macro=true";
import { default as infolDDBXJh_45_45ZHbPrzyYWmoBb__45_q_JUghKNI7fO3UFUtcMeta } from "/vercel/path0/apps/site/pages/myaccount/property/[name]/info.vue?macro=true";
import { default as salesUHPFOzLj8NwWj7v6CUQuVO1RguppcNKoQ4_TXuKX6fUMeta } from "/vercel/path0/apps/site/pages/myaccount/property/[name]/sales.vue?macro=true";
import { default as pricesW5O0gEBZuxo_nYFbZVG7BQFJZmO88lwW3_457nFW0BGS0Meta } from "/vercel/path0/apps/site/pages/myaccount/property/[name]/prices.vue?macro=true";
import { default as rentalsXAS2rQBW_QCVi2AlLPEYZCRnhBY7p4cpkq0mIst_45BKwMeta } from "/vercel/path0/apps/site/pages/myaccount/property/[name]/rentals.vue?macro=true";
import { default as calendarORCNtdN7_e1TapCpH_45446_45B866E57UK9PST_45rwV_45pSIMeta } from "/vercel/path0/apps/site/pages/myaccount/property/[name]/calendar.vue?macro=true";
import { default as _91name_93Hs1j0FjTvRTvdcU9yIS4zy9ibO_dMgdSbxI0s4v6RsgMeta } from "/vercel/path0/apps/site/pages/myaccount/property/[name].vue?macro=true";
import { default as resumeOwnerwJi0B3_dqdimcoDn3Vn2myEL_b_DbhwSmkQ8ZovZ4Z4Meta } from "/vercel/path0/apps/site/pages/reservationAgreement/[id]/resumeOwner.vue?macro=true";
import { default as resumeClientE8rT45kCXGhPc6Gf_4xynsYQcXNkvKIgyvaPX2ufi9EMeta } from "/vercel/path0/apps/site/pages/reservationAgreement/[id]/resumeClient.vue?macro=true";
import { default as successOwnerixqU7qWwl98DCtPXVzy4_45RL_awneh28qr_45lM9jui_45_45IMeta } from "/vercel/path0/apps/site/pages/reservationAgreement/[id]/successOwner.vue?macro=true";
import { default as successClientLQVkaoDeIkBv52SW3NuVdXSdk_456uT6bQXKms7QUNwLsMeta } from "/vercel/path0/apps/site/pages/reservationAgreement/[id]/successClient.vue?macro=true";
import { default as identityDocumenthjrbLXtDNY_ULU0rZbhdhMc_45Bk8JGV1Z662N6xmbrP0Meta } from "/vercel/path0/apps/site/pages/reservationAgreement/[id]/identityDocument.vue?macro=true";
import { default as clientInformation7ap73wC5LQASy5H_4Rk_TqrKtySmyinT8BD6ieBSxgkMeta } from "/vercel/path0/apps/site/pages/reservationAgreement/[id]/clientInformation.vue?macro=true";
import { default as reservationRequestOGOGxYUBonp7c7HFBjFt6HC4SgpWzY84gBTx3UGbq84Meta } from "/vercel/path0/apps/site/pages/reservationAgreement/[id]/reservationRequest.vue?macro=true";
import { default as bookingConfirmation2IdTc0RY_xzYIn0FjP4_453ZM7VNYuU3DmoYDruUZPy0QMeta } from "/vercel/path0/apps/site/pages/reservationAgreement/[id]/bookingConfirmation.vue?macro=true";
import { default as _91id_93KC1OtZ_5OdIadnOPqbmbR_5jvAArsfpf4zRhB_45EamREMeta } from "/vercel/path0/apps/site/pages/reservationAgreement/[id].vue?macro=true";
import { default as destinationAlertWEdtgFGYhNH6ISkx5dDX1JQL1a5uoJsa90w1aFRbwBUMeta } from "/vercel/path0/apps/site/pages/myaccount/destinationAlert.vue?macro=true";
import { default as _91filter_93mn4KP9HrjW3e4DredOxfO6pihTFk8Kvx9uYJvzY0JwsMeta } from "/vercel/path0/apps/site/pages/[destination]/[slug]/[filter].vue?macro=true";
import { default as _91id_93nhGSRwupX_rJygvonmYxZnGg9upAP8w36DcHRxMsEakMeta } from "/vercel/path0/apps/site/pages/myaccount/documents/checks/[id].vue?macro=true";
import { default as contractsErLofvYvd4B_45VXaXfiTDay6tQdNDR16oGfOORv_CAY8Meta } from "/vercel/path0/apps/site/pages/myaccount/documents/[house]/contracts.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexLB9f880_45NplFy4T_wDBUaHwmrNp_45bx4aaZdN2W2yVYIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/index.vue")
  },
  {
    name: "tgv___fr",
    path: "/fr/the-greek-villas",
    meta: tgvNlROzUQiWHh_45Jlp3eibn95VVW7kQxMPwpivX6E8rEfQMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/tgv.vue")
  },
  {
    name: "tgv___en",
    path: "/en/the-greek-villas",
    meta: tgvNlROzUQiWHh_45Jlp3eibn95VVW7kQxMPwpivX6E8rEfQMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/tgv.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexLB9f880_45NplFy4T_wDBUaHwmrNp_45bx4aaZdN2W2yVYIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexLB9f880_45NplFy4T_wDBUaHwmrNp_45bx4aaZdN2W2yVYIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/index.vue")
  },
  {
    name: "login___fr",
    path: "/fr/connexion",
    meta: { ...(loginmw9dUgU223jI0yzRlqeW6WCcVUg8rfn0u8c_gCK52BkMeta || {}), ...{"middleware":["login"]} },
    component: () => import("/vercel/path0/apps/site/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: { ...(loginmw9dUgU223jI0yzRlqeW6WCcVUg8rfn0u8c_gCK52BkMeta || {}), ...{"middleware":["login"]} },
    component: () => import("/vercel/path0/apps/site/pages/login.vue")
  },
  {
    name: "bonder___fr",
    path: "/fr/bonderco",
    meta: bonderYAWawE88qfsuZ717jW1Df3EcN7JizBHCd8vd8VVbnwQMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/bonder.vue")
  },
  {
    name: "bonder___en",
    path: "/en/bonderco",
    meta: bonderYAWawE88qfsuZ717jW1Df3EcN7JizBHCd8vd8VVbnwQMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/bonder.vue")
  },
  {
    name: "events___fr",
    path: "/fr/service-evenementiel",
    meta: eventsUYBmBJQ5HZ8EKSOoWGjA6XF8BHjrvjm4X6BBC0g4768Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/events.vue")
  },
  {
    name: "events___en",
    path: "/en/event-service",
    meta: eventsUYBmBJQ5HZ8EKSOoWGjA6XF8BHjrvjm4X6BBC0g4768Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/events.vue")
  },
  {
    name: "owners___fr",
    path: "/fr/proprietaires",
    meta: ownerscFeDwgl1BeTfwrI3mOjRc6gzcZjc_45UcbARIePi72wz4Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/owners.vue")
  },
  {
    name: "owners___en",
    path: "/en/owners",
    meta: ownerscFeDwgl1BeTfwrI3mOjRc6gzcZjc_45UcbARIePi72wz4Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/owners.vue")
  },
  {
    name: "search___fr",
    path: "/fr/recherche",
    meta: searchGoWTPY1ex8a452t20OtZbkm7K9_45fIW35GzeGLX9kWvUMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    meta: searchGoWTPY1ex8a452t20OtZbkm7K9_45fIW35GzeGLX9kWvUMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/search.vue")
  },
  {
    name: "tailor___fr",
    path: "/fr/notre-conciergerie-de-luxe",
    meta: tailorylcLZTiAU8QlBBXXjIGuv5MCZOAPoqKhiPGHl1KCNVwMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/tailor.vue")
  },
  {
    name: "tailor___en",
    path: "/en/our-luxury-concierge-service",
    meta: tailorylcLZTiAU8QlBBXXjIGuv5MCZOAPoqKhiPGHl1KCNVwMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/tailor.vue")
  },
  {
    name: "vallat___fr",
    path: "/fr/vallat",
    meta: vallatP6M9Tlw05obBVJpzCJbOfu1D_45n6DV1U3k3r5INlzFx4Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/vallat.vue")
  },
  {
    name: "vallat___en",
    path: "/en/vallat",
    meta: vallatP6M9Tlw05obBVJpzCJbOfu1D_45n6DV1U3k3r5INlzFx4Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/vallat.vue")
  },
  {
    name: "contact___fr",
    path: "/fr/contact",
    meta: contactp5Wa4d5J6FkfpkG9R_458BMnb3Q0ewVIszhBl5D0S4F9EMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    meta: contactp5Wa4d5J6FkfpkG9R_458BMnb3Q0ewVIszhBl5D0S4F9EMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/contact.vue")
  },
  {
    name: "sitemap___fr",
    path: "/fr/plan-du-site",
    meta: sitemapGMW_WHUClYMrTe9YDN4_45e3BnHOkfpwfPXR5ewksEeFIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/sitemap.vue")
  },
  {
    name: "sitemap___en",
    path: "/en/sitemap",
    meta: sitemapGMW_WHUClYMrTe9YDN4_45e3BnHOkfpwfPXR5ewksEeFIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/sitemap.vue")
  },
  {
    name: "addedValue___fr",
    path: "/fr/notre-valeur-ajoutee",
    meta: addedValuehxgyIAxni6P3VKHNjvWkGZT9h5CE_ubay9SbGtFBpTEMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/addedValue.vue")
  },
  {
    name: "addedValue___en",
    path: "/en/our-added-value",
    meta: addedValuehxgyIAxni6P3VKHNjvWkGZT9h5CE_ubay9SbGtFBpTEMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/addedValue.vue")
  },
  {
    name: "realEstate___fr",
    path: "/fr/immobilier-luxe-service",
    meta: realEstateHth5mjxOs5qznNCuxzTdZ7L67xsp_45RfoF3bLx7Sb3x8Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/realEstate.vue")
  },
  {
    name: "realEstate___en",
    path: "/en/luxury-real-estate-service",
    meta: realEstateHth5mjxOs5qznNCuxzTdZ7L67xsp_45RfoF3bLx7Sb3x8Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/realEstate.vue")
  },
  {
    name: "inspiration___fr",
    path: "/fr/s-inspirer",
    meta: inspiration1AJH__lc4a_oJN2LKioBOtcK8JU8CCyaEY20Qu6Cj10Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/inspiration.vue")
  },
  {
    name: "inspiration___en",
    path: "/en/get-inspired",
    meta: inspiration1AJH__lc4a_oJN2LKioBOtcK8JU8CCyaEY20Qu6Cj10Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/inspiration.vue")
  },
  {
    name: "house-slug___fr",
    path: "/fr/location-luxe/:slug()",
    meta: { ...(_91slug_93vZ_45CpD4xHYei0hpo6p9ZKpIrKEpCvFhAbjL9k76Fox4Meta || {}), ...{"middleware":["house"]} },
    component: () => import("/vercel/path0/apps/site/pages/house/[slug].vue")
  },
  {
    name: "house-slug___en",
    path: "/en/luxury-rental/:slug()",
    meta: { ...(_91slug_93vZ_45CpD4xHYei0hpo6p9ZKpIrKEpCvFhAbjL9k76Fox4Meta || {}), ...{"middleware":["house"]} },
    component: () => import("/vercel/path0/apps/site/pages/house/[slug].vue")
  },
  {
    name: "house-photos___fr",
    path: "/fr/location-luxe/:slug()/photos",
    meta: { ...(photoshXV3YY2AEKcnmRi8eRkKra3kyhhfkCSUwThH74RnhUoMeta || {}), ...{"middleware":["house"]} },
    component: () => import("/vercel/path0/apps/site/pages/house/photos.vue")
  },
  {
    name: "house-photos___en",
    path: "/en/luxury-rental/:slug()/photos",
    meta: { ...(photoshXV3YY2AEKcnmRi8eRkKra3kyhhfkCSUwThH74RnhUoMeta || {}), ...{"middleware":["house"]} },
    component: () => import("/vercel/path0/apps/site/pages/house/photos.vue")
  },
  {
    name: "feedback-id___fr",
    path: "/fr/formulaire-de-satisfaction/:id()",
    component: () => import("/vercel/path0/apps/site/pages/feedback/[id].vue")
  },
  {
    name: "feedback-id___en",
    path: "/en/feedback/:id()",
    component: () => import("/vercel/path0/apps/site/pages/feedback/[id].vue")
  },
  {
    name: "customHolidays___fr",
    path: "/fr/vacances-sur-mesure",
    meta: customHolidayslyW27XxJn9NH_EXjE_0Y6Uj5saOm8IW0qpPq2EuZeNIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/customHolidays.vue")
  },
  {
    name: "customHolidays___en",
    path: "/en/custom-holidays",
    meta: customHolidayslyW27XxJn9NH_EXjE_0Y6Uj5saOm8IW0qpPq2EuZeNIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/customHolidays.vue")
  },
  {
    name: "myaccount-menu___fr",
    path: "/fr/mon-compte/menu",
    meta: menuTDaGXdvnrSfjDMRngngFa9tHN4y4gi68DcHqpavIaGgMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/menu.vue")
  },
  {
    name: "myaccount-menu___en",
    path: "/en/my-account/menu",
    meta: menuTDaGXdvnrSfjDMRngngFa9tHN4y4gi68DcHqpavIaGgMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/menu.vue")
  },
  {
    name: "travelPartners___fr",
    path: "/fr/agences-partenaires",
    meta: travelPartnersT_456qTUFBPLewkZ_OrL5smXShk0q5LaYIuEQLUVjYVc0Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/travelPartners.vue")
  },
  {
    name: "travelPartners___en",
    path: "/en/travel-partners",
    meta: travelPartnersT_456qTUFBPLewkZ_OrL5smXShk0q5LaYIuEQLUVjYVc0Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/travelPartners.vue")
  },
  {
    name: "wishlist___fr",
    path: "/fr/wishlist",
    meta: { ...(indexrX4h12gryidZzSlXMS2bYqE_459I8S5aSJaQwCA8LNNpEMeta || {}), ...{"middleware":["redirect-wishlist"]} },
    component: () => import("/vercel/path0/apps/site/pages/wishlist/index.vue")
  },
  {
    name: "wishlist___en",
    path: "/en/wishlist",
    meta: { ...(indexrX4h12gryidZzSlXMS2bYqE_459I8S5aSJaQwCA8LNNpEMeta || {}), ...{"middleware":["redirect-wishlist"]} },
    component: () => import("/vercel/path0/apps/site/pages/wishlist/index.vue")
  },
  {
    name: "houseCollection___fr",
    path: "/fr/collection-de-maisons",
    component: () => import("/vercel/path0/apps/site/pages/houseCollection.vue")
  },
  {
    name: "houseCollection___en",
    path: "/en/collection-of-houses",
    component: () => import("/vercel/path0/apps/site/pages/houseCollection.vue")
  },
  {
    name: "legal-termsOfUse___fr",
    path: "/fr/conditions-generales-utilisation",
    meta: termsOfUse_45xJaPIFwc7LwPp3MRaBWNEiYRr_45QSVR4JsEV0yMOjV8Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/legal/termsOfUse.vue")
  },
  {
    name: "legal-termsOfUse___en",
    path: "/en/terms-of-use",
    meta: termsOfUse_45xJaPIFwc7LwPp3MRaBWNEiYRr_45QSVR4JsEV0yMOjV8Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/legal/termsOfUse.vue")
  },
  {
    name: "myaccount-profile___fr",
    path: "/fr/mon-compte/profil",
    meta: profile_45_45QofDcg_45HYfb_45roMB6pHo_452GNEASp39HQYXR0FyaIkMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/profile.vue")
  },
  {
    name: "myaccount-profile___en",
    path: "/en/my-account/profile",
    meta: profile_45_45QofDcg_45HYfb_45roMB6pHo_452GNEASp39HQYXR0FyaIkMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/profile.vue")
  },
  {
    name: "stayProposal-edit___fr",
    path: "/fr/modifier-proposition-de-sejour",
    meta: { ...(editjGjjyiJ2FkUjWlc7WDEOFY7DbItEXElpG5i9xzMtC5AMeta || {}), ...{"middleware":["stay-proposal-edit"]} },
    component: () => import("/vercel/path0/apps/site/pages/stayProposal/edit.vue")
  },
  {
    name: "stayProposal-edit___en",
    path: "/en/edit-stay-proposal",
    meta: { ...(editjGjjyiJ2FkUjWlc7WDEOFY7DbItEXElpG5i9xzMtC5AMeta || {}), ...{"middleware":["stay-proposal-edit"]} },
    component: () => import("/vercel/path0/apps/site/pages/stayProposal/edit.vue")
  },
  {
    name: "myaccount-bookings___fr",
    path: "/fr/mon-compte/reservations",
    meta: bookingsMJc49XW0mSm4a_45Qk1Y9B5DeDH3Qa8fY1i55OsZg1UgkMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/bookings.vue")
  },
  {
    name: "myaccount-bookings___en",
    path: "/en/my-account/bookings",
    meta: bookingsMJc49XW0mSm4a_45Qk1Y9B5DeDH3Qa8fY1i55OsZg1UgkMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/bookings.vue")
  },
  {
    name: "realEstateListings___fr",
    path: "/fr/immobilier-luxe-annonces",
    meta: realEstateListingsroN_h11Pu3XHi5UXJcPthf76QONDgDAZFH8a6_45dAo9wMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/realEstateListings.vue")
  },
  {
    name: "realEstateListings___en",
    path: "/en/luxury-real-estate-listing",
    meta: realEstateListingsroN_h11Pu3XHi5UXJcPthf76QONDgDAZFH8a6_45dAo9wMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/realEstateListings.vue")
  },
  {
    name: "legal-privacyPolicy___fr",
    path: "/fr/politique-confidentialite",
    meta: privacyPolicyyB53yXa0HVtDe_VlWt0FcfXYKeaiUQORvk_fCmbtPrcMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/legal/privacyPolicy.vue")
  },
  {
    name: "legal-privacyPolicy___en",
    path: "/en/privacy-policy",
    meta: privacyPolicyyB53yXa0HVtDe_VlWt0FcfXYKeaiUQORvk_fCmbtPrcMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/legal/privacyPolicy.vue")
  },
  {
    name: "destination-name___fr",
    path: "/fr/:destination()/:name()",
    meta: {"middleware":["search-destination-validation"]},
    component: () => import("/vercel/path0/apps/site/pages/[destination]/[name].vue")
  },
  {
    name: "destination-name___en",
    path: "/en/:destination()/:name()",
    meta: {"middleware":["search-destination-validation"]},
    component: () => import("/vercel/path0/apps/site/pages/[destination]/[name].vue")
  },
  {
    name: "house-preorder-error___fr",
    path: "/fr/location-luxe/:slug()/pose-d-option/erreur",
    meta: errorRyOCZSy6nGrdqDsu8bYACWFFaXHjylgQgK8pHSmIdysMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/house/preorder/error.vue")
  },
  {
    name: "house-preorder-error___en",
    path: "/en/luxury-rental/:slug()/pre-order/error",
    meta: errorRyOCZSy6nGrdqDsu8bYACWFFaXHjylgQgK8pHSmIdysMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/house/preorder/error.vue")
  },
  {
    name: "house-preorder___fr",
    path: "/fr/location-luxe/:slug()/pose-d-option",
    meta: indexgXQpU3P4vPdWcJb_45kCPQkKSivrE2_45Crq7vcd4xIL6WEMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/house/preorder/index.vue")
  },
  {
    name: "house-preorder___en",
    path: "/en/luxury-rental/:slug()/pre-order",
    meta: indexgXQpU3P4vPdWcJb_45kCPQkKSivrE2_45Crq7vcd4xIL6WEMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/house/preorder/index.vue")
  },
  {
    name: "payment-deposit-id___fr",
    path: "/fr/payment/deposit/:id()",
    meta: _91id_93B_XHTZy8UDcVvpgRcNkqvGvF_45pCaYEZUFM0Pl_mHlRgMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/deposit/[id].vue"),
    children: [
  {
    name: "payment-deposit-id-form___fr",
    path: "/fr/paiements/caution/:id()",
    meta: formDu8VU3krJK2k4Bl8mPfazFFxFao2MVoafTQCuXuiYbIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/deposit/[id]/form.vue")
  },
  {
    name: "payment-deposit-id-error___fr",
    path: "/fr/paiements/caution/:id()/erreur",
    meta: errorbQt96nzQBwJIStSw01ClptgselYmI3sQI1Q2Y1af9iUMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/deposit/[id]/error.vue")
  },
  {
    name: "payment-deposit-id-success___fr",
    path: "/fr/paiements/caution/:id()/succes",
    meta: successhSlpws43RKDxn325S10czwx76_adG2ihPWbfSjnQmdEMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/deposit/[id]/success.vue")
  }
]
  },
  {
    name: "payment-deposit-id___en",
    path: "/en/payment/deposit/:id()",
    meta: _91id_93B_XHTZy8UDcVvpgRcNkqvGvF_45pCaYEZUFM0Pl_mHlRgMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/deposit/[id].vue"),
    children: [
  {
    name: "payment-deposit-id-form___en",
    path: "/en/payments/deposit/:id()",
    meta: formDu8VU3krJK2k4Bl8mPfazFFxFao2MVoafTQCuXuiYbIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/deposit/[id]/form.vue")
  },
  {
    name: "payment-deposit-id-error___en",
    path: "/en/payments/deposit/:id()/error",
    meta: errorbQt96nzQBwJIStSw01ClptgselYmI3sQI1Q2Y1af9iUMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/deposit/[id]/error.vue")
  },
  {
    name: "payment-deposit-id-success___en",
    path: "/en/payments/deposit/:id()/success",
    meta: successhSlpws43RKDxn325S10czwx76_adG2ihPWbfSjnQmdEMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/deposit/[id]/success.vue")
  }
]
  },
  {
    name: "screenshot-villabook___fr",
    path: "/fr/villabook/:id()",
    meta: villabookfJnrB6Abe5bgeMoDiUak6H5WNBk2va5dn0z0_AX_e_45QMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/screenshot/villabook.vue")
  },
  {
    name: "screenshot-villabook___en",
    path: "/en/villabook/:id()",
    meta: villabookfJnrB6Abe5bgeMoDiUak6H5WNBk2va5dn0z0_AX_e_45QMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/screenshot/villabook.vue")
  },
  {
    name: "stayProposal-token___fr",
    path: "/fr/proposition-de-sejour/:token()",
    meta: _91token_938851rEqIcAP_VZ2GyUQ_45qYLFzB23BoiJR_45Rpzu0arGcMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/stayProposal/[token].vue")
  },
  {
    name: "stayProposal-token___en",
    path: "/en/stay-proposal/:token()",
    meta: _91token_938851rEqIcAP_VZ2GyUQ_45qYLFzB23BoiJR_45Rpzu0arGcMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/stayProposal/[token].vue")
  },
  {
    name: "legal-ownerConditions___fr",
    path: "/fr/conditions-proprietaire",
    meta: ownerConditionsoDT7YXiHFgke3oxmJVdGeyhSOXLJlq3NwhxHdqUvsv8Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/legal/ownerConditions.vue")
  },
  {
    name: "legal-ownerConditions___en",
    path: "/en/owner-conditions",
    meta: ownerConditionsoDT7YXiHFgke3oxmJVdGeyhSOXLJlq3NwhxHdqUvsv8Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/legal/ownerConditions.vue")
  },
  {
    name: "payment-payin-error___fr",
    path: "/fr/paiements/:payin()/erreur",
    meta: errorlduhARou_AlfAoggVH5MQz_7g5T4eNiU2M6UjyFCZ1cMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/[payin]/error.vue")
  },
  {
    name: "payment-payin-error___en",
    path: "/en/payments/:payin()/error",
    meta: errorlduhARou_AlfAoggVH5MQz_7g5T4eNiU2M6UjyFCZ1cMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/[payin]/error.vue")
  },
  {
    name: "payment-payin___fr",
    path: "/fr/paiements/:payin()",
    meta: index3yDexzST5rsL0W7A5cli6hBTo8qL2EFnU0WsAk7EfMAMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/[payin]/index.vue")
  },
  {
    name: "payment-payin___en",
    path: "/en/payments/:payin()",
    meta: index3yDexzST5rsL0W7A5cli6hBTo8qL2EFnU0WsAk7EfMAMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/[payin]/index.vue")
  },
  {
    name: "screenshot-whitebrand___fr",
    path: "/fr/preview/:id()",
    meta: whitebrandBFscijZgCAxjdKEDGzrXQJzMUo9BwQL5ry5fUyOdhoYMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/screenshot/whitebrand.vue")
  },
  {
    name: "screenshot-whitebrand___en",
    path: "/en/preview/:id()",
    meta: whitebrandBFscijZgCAxjdKEDGzrXQJzMUo9BwQL5ry5fUyOdhoYMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/screenshot/whitebrand.vue")
  },
  {
    name: "house-preorder-success___fr",
    path: "/fr/location-luxe/:slug()/pose-d-option/succes",
    meta: successoD_45VZ63umy8dMSoNzwIOFJLqoNMaAupRpS_HAXYlSI4Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/house/preorder/success.vue")
  },
  {
    name: "house-preorder-success___en",
    path: "/en/luxury-rental/:slug()/pre-order/success",
    meta: successoD_45VZ63umy8dMSoNzwIOFJLqoNMaAupRpS_HAXYlSI4Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/house/preorder/success.vue")
  },
  {
    name: "legal-clientConditions___fr",
    path: "/fr/conditions-client",
    meta: clientConditionsGonqByktirayVfY5Shkcn0ceIsS5VMlS8Zp5V2kHdywMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/legal/clientConditions.vue")
  },
  {
    name: "legal-clientConditions___en",
    path: "/en/client-conditions",
    meta: clientConditionsGonqByktirayVfY5Shkcn0ceIsS5VMlS8Zp5V2kHdywMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/legal/clientConditions.vue")
  },
  {
    name: "wishlist-token___fr",
    path: "/fr/wishlist/:token()",
    meta: index_igeO5qBT4m3iQLlJuBQSU9JxHCvwd0IDvkXDn9xF_45oMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/wishlist/[token]/index.vue")
  },
  {
    name: "wishlist-token___en",
    path: "/en/wishlist/:token()",
    meta: index_igeO5qBT4m3iQLlJuBQSU9JxHCvwd0IDvkXDn9xF_45oMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/wishlist/[token]/index.vue")
  },
  {
    name: "payment-payin-success___fr",
    path: "/fr/paiements/:payin()/succes",
    meta: successZJ15YeIajLjOK3W9J54HEI02KYfeVuiP2Iyp2_45_9rTIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/[payin]/success.vue")
  },
  {
    name: "payment-payin-success___en",
    path: "/en/payments/:payin()/success",
    meta: successZJ15YeIajLjOK3W9J54HEI02KYfeVuiP2Iyp2_45_9rTIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/payment/[payin]/success.vue")
  },
  {
    name: "wishlist-token-shared___fr",
    path: "/fr/wishlist/:token()/partage",
    meta: sharedA8lOEZF86gDn30yF4xCtHzHP1aTD1LWzq7n6KdCnaP0Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/wishlist/[token]/shared.vue")
  },
  {
    name: "wishlist-token-shared___en",
    path: "/en/wishlist/:token()/shared",
    meta: sharedA8lOEZF86gDn30yF4xCtHzHP1aTD1LWzq7n6KdCnaP0Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/wishlist/[token]/shared.vue")
  },
  {
    name: "house-transaction-slug___fr",
    path: "/fr/immobilier-luxe/:slug()",
    meta: { ...(_91slug_93zlln62r_u2695kmDVddOXZROaDHV6rxGfx_dZ__ZaR8Meta || {}), ...{"middleware":["house-transaction"]} },
    component: () => import("/vercel/path0/apps/site/pages/house/transaction/[slug].vue")
  },
  {
    name: "house-transaction-slug___en",
    path: "/en/luxury-real-estate/:slug()",
    meta: { ...(_91slug_93zlln62r_u2695kmDVddOXZROaDHV6rxGfx_dZ__ZaR8Meta || {}), ...{"middleware":["house-transaction"]} },
    component: () => import("/vercel/path0/apps/site/pages/house/transaction/[slug].vue")
  },
  {
    name: "house-transaction-photos___fr",
    path: "/fr/immobilier-luxe/:slug()/photos",
    meta: { ...(photosd55xP2CVvEmxoY3w9wWcecLTiJeN4bC5Eg9_45OP7UnmQMeta || {}), ...{"middleware":["house-transaction"]} },
    component: () => import("/vercel/path0/apps/site/pages/house/transaction/photos.vue")
  },
  {
    name: "house-transaction-photos___en",
    path: "/en/luxury-real-estate/:slug()/photos",
    meta: { ...(photosd55xP2CVvEmxoY3w9wWcecLTiJeN4bC5Eg9_45OP7UnmQMeta || {}), ...{"middleware":["house-transaction"]} },
    component: () => import("/vercel/path0/apps/site/pages/house/transaction/photos.vue")
  },
  {
    name: "myaccount-documents___fr",
    path: "/fr/mon-compte/documents",
    meta: indexaeu1vMOcDHkE7akfYQ01_45RJkRKbGIdxT2nsIXA2CcjIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/documents/index.vue")
  },
  {
    name: "myaccount-documents___en",
    path: "/en/my-account/documents",
    meta: indexaeu1vMOcDHkE7akfYQ01_45RJkRKbGIdxT2nsIXA2CcjIMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/documents/index.vue")
  },
  {
    name: "myaccount-property-name___fr",
    path: "/fr/mon-compte/proprietes/:name()",
    meta: { ...(_91name_93Hs1j0FjTvRTvdcU9yIS4zy9ibO_dMgdSbxI0s4v6RsgMeta || {}), ...{"middleware":["unapproved-contract-information"]} },
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name].vue"),
    children: [
  {
    name: "myaccount-property-name-info___fr",
    path: "informations-contrat",
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name]/info.vue")
  },
  {
    name: "myaccount-property-name-sales___fr",
    path: "ventes",
    meta: {"middleware":["property-sales"]},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name]/sales.vue")
  },
  {
    name: "myaccount-property-name-prices___fr",
    path: "prix",
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name]/prices.vue")
  },
  {
    name: "myaccount-property-name-rentals___fr",
    path: "locations",
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name]/rentals.vue")
  },
  {
    name: "myaccount-property-name-calendar___fr",
    path: "calendrier",
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name]/calendar.vue")
  }
]
  },
  {
    name: "myaccount-property-name___en",
    path: "/en/my-account/properties/:name()",
    meta: { ...(_91name_93Hs1j0FjTvRTvdcU9yIS4zy9ibO_dMgdSbxI0s4v6RsgMeta || {}), ...{"middleware":["unapproved-contract-information"]} },
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name].vue"),
    children: [
  {
    name: "myaccount-property-name-info___en",
    path: "contract-information",
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name]/info.vue")
  },
  {
    name: "myaccount-property-name-sales___en",
    path: "sales",
    meta: {"middleware":["property-sales"]},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name]/sales.vue")
  },
  {
    name: "myaccount-property-name-prices___en",
    path: "prices",
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name]/prices.vue")
  },
  {
    name: "myaccount-property-name-rentals___en",
    path: "rentals",
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name]/rentals.vue")
  },
  {
    name: "myaccount-property-name-calendar___en",
    path: "calendar",
    component: () => import("/vercel/path0/apps/site/pages/myaccount/property/[name]/calendar.vue")
  }
]
  },
  {
    name: "reservationAgreement-id___fr",
    path: "/fr/reservationAgreement/:id()",
    meta: _91id_93KC1OtZ_5OdIadnOPqbmbR_5jvAArsfpf4zRhB_45EamREMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id].vue"),
    children: [
  {
    name: "reservationAgreement-id-resumeOwner___fr",
    path: "/fr/demande-de-reservation/:id()/recapitulatif",
    meta: resumeOwnerwJi0B3_dqdimcoDn3Vn2myEL_b_DbhwSmkQ8ZovZ4Z4Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/resumeOwner.vue")
  },
  {
    name: "reservationAgreement-id-resumeClient___fr",
    path: "/fr/contrat-de-location/:id()/recapitulatif",
    meta: resumeClientE8rT45kCXGhPc6Gf_4xynsYQcXNkvKIgyvaPX2ufi9EMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/resumeClient.vue")
  },
  {
    name: "reservationAgreement-id-successOwner___fr",
    path: "/fr/demande-de-reservation/:id()/accepter",
    meta: successOwnerixqU7qWwl98DCtPXVzy4_45RL_awneh28qr_45lM9jui_45_45IMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/successOwner.vue")
  },
  {
    name: "reservationAgreement-id-successClient___fr",
    path: "/fr/contrat-de-location/:id()/paiement",
    meta: successClientLQVkaoDeIkBv52SW3NuVdXSdk_456uT6bQXKms7QUNwLsMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/successClient.vue")
  },
  {
    name: "reservationAgreement-id-identityDocument___fr",
    path: "/fr/contrat-de-location/:id()/document-identite",
    meta: identityDocumenthjrbLXtDNY_ULU0rZbhdhMc_45Bk8JGV1Z662N6xmbrP0Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/identityDocument.vue")
  },
  {
    name: "reservationAgreement-id-clientInformation___fr",
    path: "/fr/contrat-de-location/:id()/information-client",
    meta: clientInformation7ap73wC5LQASy5H_4Rk_TqrKtySmyinT8BD6ieBSxgkMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/clientInformation.vue")
  },
  {
    name: "reservationAgreement-id-reservationRequest___fr",
    path: "/fr/demande-de-reservation/:id()/confirmer",
    meta: reservationRequestOGOGxYUBonp7c7HFBjFt6HC4SgpWzY84gBTx3UGbq84Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/reservationRequest.vue")
  },
  {
    name: "reservationAgreement-id-bookingConfirmation___fr",
    path: "/fr/contrat-de-location/:id()/confirmer",
    meta: bookingConfirmation2IdTc0RY_xzYIn0FjP4_453ZM7VNYuU3DmoYDruUZPy0QMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/bookingConfirmation.vue")
  }
]
  },
  {
    name: "reservationAgreement-id___en",
    path: "/en/reservationAgreement/:id()",
    meta: _91id_93KC1OtZ_5OdIadnOPqbmbR_5jvAArsfpf4zRhB_45EamREMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id].vue"),
    children: [
  {
    name: "reservationAgreement-id-resumeOwner___en",
    path: "/en/reservation-request/:id()/resume",
    meta: resumeOwnerwJi0B3_dqdimcoDn3Vn2myEL_b_DbhwSmkQ8ZovZ4Z4Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/resumeOwner.vue")
  },
  {
    name: "reservationAgreement-id-resumeClient___en",
    path: "/en/rental-contract/:id()/resume",
    meta: resumeClientE8rT45kCXGhPc6Gf_4xynsYQcXNkvKIgyvaPX2ufi9EMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/resumeClient.vue")
  },
  {
    name: "reservationAgreement-id-successOwner___en",
    path: "/en/reservation-request/:id()/accept-client",
    meta: successOwnerixqU7qWwl98DCtPXVzy4_45RL_awneh28qr_45lM9jui_45_45IMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/successOwner.vue")
  },
  {
    name: "reservationAgreement-id-successClient___en",
    path: "/en/rental-contract/:id()/payment",
    meta: successClientLQVkaoDeIkBv52SW3NuVdXSdk_456uT6bQXKms7QUNwLsMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/successClient.vue")
  },
  {
    name: "reservationAgreement-id-identityDocument___en",
    path: "/en/rental-contract/:id()/identity-documents",
    meta: identityDocumenthjrbLXtDNY_ULU0rZbhdhMc_45Bk8JGV1Z662N6xmbrP0Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/identityDocument.vue")
  },
  {
    name: "reservationAgreement-id-clientInformation___en",
    path: "/en/rental-contract/:id()/client-information",
    meta: clientInformation7ap73wC5LQASy5H_4Rk_TqrKtySmyinT8BD6ieBSxgkMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/clientInformation.vue")
  },
  {
    name: "reservationAgreement-id-reservationRequest___en",
    path: "/en/reservation-request/:id()/confirm",
    meta: reservationRequestOGOGxYUBonp7c7HFBjFt6HC4SgpWzY84gBTx3UGbq84Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/reservationRequest.vue")
  },
  {
    name: "reservationAgreement-id-bookingConfirmation___en",
    path: "/en/rental-contract/:id()/confirmation",
    meta: bookingConfirmation2IdTc0RY_xzYIn0FjP4_453ZM7VNYuU3DmoYDruUZPy0QMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/reservationAgreement/[id]/bookingConfirmation.vue")
  }
]
  },
  {
    name: "myaccount-destinationAlert___fr",
    path: "/fr/mon-compte/mes-alertes-destination",
    meta: destinationAlertWEdtgFGYhNH6ISkx5dDX1JQL1a5uoJsa90w1aFRbwBUMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/destinationAlert.vue")
  },
  {
    name: "myaccount-destinationAlert___en",
    path: "/en/my-account/my-destination-alerts",
    meta: destinationAlertWEdtgFGYhNH6ISkx5dDX1JQL1a5uoJsa90w1aFRbwBUMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/destinationAlert.vue")
  },
  {
    name: "destination-slug-filter___fr",
    path: "/fr/:destination()/:slug()/:filter()",
    meta: { ...(_91filter_93mn4KP9HrjW3e4DredOxfO6pihTFk8Kvx9uYJvzY0JwsMeta || {}), ...{"middleware":["search-destination-filter-validation"]} },
    component: () => import("/vercel/path0/apps/site/pages/[destination]/[slug]/[filter].vue")
  },
  {
    name: "destination-slug-filter___en",
    path: "/en/:destination()/:slug()/:filter()",
    meta: { ...(_91filter_93mn4KP9HrjW3e4DredOxfO6pihTFk8Kvx9uYJvzY0JwsMeta || {}), ...{"middleware":["search-destination-filter-validation"]} },
    component: () => import("/vercel/path0/apps/site/pages/[destination]/[slug]/[filter].vue")
  },
  {
    name: "myaccount-documents-checks-id___fr",
    path: "/fr/mon-compte/documents/checks/:id()",
    meta: _91id_93nhGSRwupX_rJygvonmYxZnGg9upAP8w36DcHRxMsEakMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/documents/checks/[id].vue")
  },
  {
    name: "myaccount-documents-checks-id___en",
    path: "/en/my-account/documents/checks/:id()",
    meta: _91id_93nhGSRwupX_rJygvonmYxZnGg9upAP8w36DcHRxMsEakMeta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/documents/checks/[id].vue")
  },
  {
    name: "myaccount-documents-house-contracts___fr",
    path: "/fr/mon-compte/documents/:houseId()/contrats",
    meta: contractsErLofvYvd4B_45VXaXfiTDay6tQdNDR16oGfOORv_CAY8Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/documents/[house]/contracts.vue")
  },
  {
    name: "myaccount-documents-house-contracts___en",
    path: "/en/my-account/documents/:houseId()/contracts",
    meta: contractsErLofvYvd4B_45VXaXfiTDay6tQdNDR16oGfOORv_CAY8Meta || {},
    component: () => import("/vercel/path0/apps/site/pages/myaccount/documents/[house]/contracts.vue")
  }
]